import React, { Fragment } from 'react';
import {
  IBasicFilterFieldsFragment,
  ILogicalOperatorFieldsFragment,
} from '../../../../../../utils/apollo/graphqlSchema';
import DashboardFilterEditableCondition from './DashboardFilterEditableCondition';
import * as DashboardFilterViewUI from './DashboardFilterViewUI';
import DashboardLogicOp from './DashboardLogicOp';
import { dashboardCustomizationSetFilter } from '../../../../../../redux/slices/dashboards/dashboardInstance';
import { useAppDispatch } from '../../../../../../redux/hooks';
import produce from 'immer';
import { isNil } from 'lodash';

interface IProps {
  filter: IBasicFilterFieldsFragment;
  logicOps: ILogicalOperatorFieldsFragment[];
  includeAnyValue: boolean;
}

const DashboardBasicFilterView = ({
  filter,
  logicOps,
  includeAnyValue,
}: IProps) => {
  const dispatch = useAppDispatch();

  const onChangeLogicOp = (
    conditionIndex: number,
    newLogicOp: ILogicalOperatorFieldsFragment,
  ) => {
    const newFilter = produce(filter, (draft) => {
      draft.logicOps[conditionIndex] = newLogicOp;
    });

    dispatch(
      dashboardCustomizationSetFilter({
        newFilter,
      }),
    );
  };

  return (
    <>
      {filter.conditions.map((condition, conditionIndex) => {
        const logicOpIndex = conditionIndex > 0 ? conditionIndex - 1 : null;
        return (
          <Fragment
            key={`Dashboard-Filter-Condition-${conditionIndex}-${condition.__typename}`}
          >
            {!isNil(logicOpIndex) && (
              <DashboardFilterViewUI.LogicOpWrapper>
                <DashboardLogicOp
                  type="condition"
                  operator={filter.logicOps[logicOpIndex]}
                  logicOps={logicOps}
                  onChange={(newLogicOp) =>
                    onChangeLogicOp(logicOpIndex, newLogicOp)
                  }
                />
              </DashboardFilterViewUI.LogicOpWrapper>
            )}
            <DashboardFilterEditableCondition
              filter={filter}
              condition={condition}
              conditionIndex={conditionIndex}
              includeAnyValue={includeAnyValue}
            />
          </Fragment>
        );
      })}
    </>
  );
};

export default DashboardBasicFilterView;
